const metaAuth = {
  auth: 1,
  keepAlive: false,
};

export default [
  {
    path: "/swbd2",
    name: "swbd2",
    meta: metaAuth,
    component: () => import("@/views/basePcTwo/index.vue"),
  },
  {
    path: "/fsbd5",
    name: "fsbd5",
    meta: metaAuth,
    component: () => import("@/views/basePcTwo/index.vue"),
  },
];
